import React from 'react';
import BankImportPage from './BankImportPage';

export default function CreditMutuelEURPage() {
  return (
    <BankImportPage
      title="Credit Mutuel EUR Import"
      description="Import Credit Mutuel EUR transactions using the 7-field format."
      fieldLabels={['Date', 'Valeur', 'Libellé', 'Débit', 'Crédit', 'Solde', 'Dev']}
      listEndpoint="/api/credit-mutuel/eur"
      importEndpoint="/api/credit-mutuel/import/eur"
      bankId="CREDIT_MUTUEL"
      emptyText="No Credit Mutuel EUR records found."
      hideAccountSelector
    />
  );
}
